import { render, staticRenderFns } from "./EditModule.vue?vue&type=template&id=56394b96&scoped=true"
import script from "./EditModule.vue?vue&type=script&lang=js"
export * from "./EditModule.vue?vue&type=script&lang=js"
import style0 from "./EditModule.vue?vue&type=style&index=0&id=56394b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56394b96",
  null
  
)

export default component.exports